import "./cart-content";
import "./gifting-content-trigger";
import "./gift-wrap-form";
import "./gift-message-form";

class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.requestId = 1;
    this.closeButton = this.querySelector("[data-close]");
    this.content = this.querySelector(".mini-cart__content");

    this.closeButton?.addEventListener("click", () => {
      if (window.modalStack?.length) return;
      this._close();
    });
    this.addEventListener("click", (e) => {
      if (e.target.closest(".mini-cart__content")) return;
      if (window.modalStack?.length) return;

      this._close();
    });

    this.handleDocumentClick = (e) => {
      // Ignore clicks on items no longer in DOM
      if (!document.body.contains(e.target)) return;
      if (window.modalStack?.length) return;

      if (
        !this.content.contains(e.target) &&
        !e.target.closest("[data-within-cart-modal]")
      ) {
        this._close();
      }
    };

    document.addEventListener("click", this.handleDocumentClick);

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        if (window.modalStack?.length) return;
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    document.addEventListener("mini-cart:open", () => this._open());
    document.addEventListener("mini-cart:close", () => this._close());
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  _toggle() {
    this.hasAttribute("open") ? this._close() : this._open();
  }

  _open() {
    if (this.hasAttribute("open")) return;

    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      window.openFullDimmer(this);
      window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      window.trapFocus(this, this.closeButton);
    });
  }

  _close() {
    if (!this.hasAttribute("open")) return;

    this.removeAttribute("open");
    window.closeFullDimmer(this);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.hasAttribute("open")) return;
      this.style.display = null;
      window.removeTrapFocus(this.returnFocusEl);
      window.unlockScroll(this);
    };
    this.addEventListener("transitionend", onEnd);
  }
}

if (!customElements.get("mini-cart")) {
  customElements.define("mini-cart", MiniCart);
}
